import {ACTION_TYPES} from "./actions";

export const initialState = {customerType: "regular"};

function reducer(state, action) {
  return new Promise((resolve) => {
    setTimeout(() => {
      switch (action.type) {
        case ACTION_TYPES.TOKEN_STATUS:
          resolve({...state, ...action.payload});
          break;
        case ACTION_TYPES.SET_CUSTOMER_ID:
          resolve({...state, ...action.payload});
          break;
        case ACTION_TYPES.ENABLE_SLOT_REBOOKING:
          resolve({...state, slotRebookingEnabled: true});
          break;
        default:
          resolve(state);
          break;
      }
    }, 1000);
  });
}

export default reducer;
